document.addEventListener('click', (e) => {
    if (e.target.dataset.stepNext) {
        const step = e.target.dataset.stepNext
        const stepElement = document.querySelector(`[data-step="${step}"]`)
        stepElement.open = true
        const rect = stepElement.getBoundingClientRect()

        window.scrollTo({
            top: window.scrollY + rect.top - 160,
            behavior: 'smooth',
        })
    }
})
